import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import travelModule from './travel.module';

Vue.use(Vuex);

const ttl = 1000 * 60 * 60 * 24; //24h in milliseconds

export default new Vuex.Store({
    modules: {
        travelModule
    },
    plugins: [createPersistedState({
        paths: ['travelModule'],
        storage: {
            getItem: key => {
                // console.log("Getting: ", key)
                const itemStr = localStorage.getItem(key)

                if (!itemStr) {
                    return null
                }

                const item = JSON.parse(itemStr)
                const now = new Date()

                if (now.getTime() > item.expiry) {
                    localStorage.removeItem(key)
                    return null
                }

                return item.value
            },
            setItem: (key, value) => {
                // console.log("Setting: ", key, value);

                const now = new Date()
                const item = {
                    value: value,
                    expiry: now.getTime() + ttl,
                }
                localStorage.setItem(key, JSON.stringify(item))
            },
            removeItem: key => {
                localStorage.removeItem(key);
            }
        }
    })]  //persists the state to localStorage
});
